import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class AppStore {
    version = '2.0';

    syncAction = '';
    directLink = false;
    customCss = null;
    observed = {
        progress: false,
    };
    locale = 'en';
    constructor() {
        makeObservable(this, {
            observed: observable,
        });
        withActions(this, actions);
    }

}

export function useAppStore () {
    const { store } = useStores();
    return store.appStore;
}
